/* eslint no-underscore-dangle: ["error", { "allow": ["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] }] */
import React from 'react';
import ReactDOM from 'react-dom';
import './sass/index.scss';
import Root from './components/Root';
import * as serviceWorker from './serviceWorker';
import 'normalize.css';
import './FontAwesomeIcons';
import store from './store';

export default ReactDOM.render(
  <Root store={store} />,
  document.getElementById('root') || document.createElement('div'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
